import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-white rounded-lg p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_c49fc58a-1b62-4468-a1f5-1303911b819b/artifacts/ef65om0u_Screenshot%202026-01-12%20at%2015.17.19.png"
                  alt="AIM TRADE - International Trade and Development"
                  className="h-14 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sectors')}
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-blue-400 transition-colors duration-200"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">{t('footer.contactTitle')}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-blue-400" />
                <div>
                  <a href="mailto:info@aimtradejo.com" className="hover:text-blue-400 transition-colors duration-200 block">
                    info@aimtradejo.com
                  </a>
                  <a href="mailto:international@aimtradejo.com" className="hover:text-blue-400 transition-colors duration-200 block">
                    international@aimtradejo.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-blue-400" />
                <div>
                  <a href="tel:+962799172424" className="hover:text-blue-400 transition-colors duration-200 block">
                    +962 799 172 424
                  </a>
                  <a href="tel:+4917663106693" className="hover:text-blue-400 transition-colors duration-200 block">
                    +49 176 631 066 93
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-blue-400" />
                <div>
                  <span className="block">Amman, Jordan</span>
                  <span className="block">Munich, Germany</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>{t('footer.copyright').replace('{year}', new Date().getFullYear())}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;